var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2038 9.25644C19.1538 9.88584 20.4463 9.78202 21.2834 8.94499C22.2389 7.98944 22.2389 6.44019 21.2834 5.48464C20.7174 4.91868 19.9432 4.68793 19.2074 4.7924C19.3118 4.05668 19.081 3.28256 18.5151 2.71666C17.5596 1.76111 16.0104 1.76111 15.0549 2.71666C14.2179 3.55366 14.1141 4.84619 14.7434 5.79622L5.79624 14.7436C4.84622 14.1142 3.55366 14.218 2.71664 15.055C1.76112 16.0106 1.76112 17.5598 2.71664 18.5154C3.28259 19.0813 4.05681 19.3121 4.79259 19.2076C4.68822 19.9433 4.91897 20.7174 5.48486 21.2833C6.44038 22.2389 7.98959 22.2389 8.94512 21.2833C9.7821 20.4463 9.88594 19.1538 9.25663 18.2038L18.2038 9.25644Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBone);
export default __webpack_public_path__ + "static/media/bone.14e6db62b879edc84f45a43292a64dc5.svg";
export { ForwardRef as ReactComponent };